import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../redux/axios/axios";
const fetchPeopleBehindData = async () => {
  try {
    const response = await axiosInstance.get("/people-behind");
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

const useSupportSpeaks = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["peopleBehindData"],
    queryFn: fetchPeopleBehindData,
  });
  return { data, isLoading, isError, error };
};

export default useSupportSpeaks;
